// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { IntegrationProviderSchema } from '../inputTypeSchemas/IntegrationProviderSchema'

/////////////////////////////////////////
// EXTERNAL REFERENCE SCHEMA
/////////////////////////////////////////

export const ExternalReferenceSchema = z.object({
  provider: IntegrationProviderSchema,
  id: z.string(),
  key: z.string().nullable(),
  url: z.string().nullable(),
})

export type ExternalReference = z.infer<typeof ExternalReferenceSchema>

export default ExternalReferenceSchema;
